import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CustomMindmapProvider } from 'Custom-Mindmap';
import Header from '../Header';
import MindMapContainer from '../MindMapContainer/MindMapContainer';
import { ChatBox } from '../ChatBox/ChatBox';
import SocketListener from '../SokcetListner/socketLister';
import { MindMapContext } from '../../Context/contex';
import { hasCachedDocument } from '../../Utils/documentCache';

const MainLayout = () => {
    const { documentId } = useParams();
    const { isTemplateDocument, isReadOnly } = MindMapContext();
    const [contentLoading, setContentLoading] = useState(true);

    // Editable, non-template cache hit — render the Header + offline-status
    // instantly so they don't flicker when the background fetch toggles
    // contentLoading.
    const isDocumentCached = useMemo(
        () => !isTemplateDocument && !isReadOnly && hasCachedDocument(documentId),
        [documentId, isTemplateDocument, isReadOnly]
    );
    const showChrome = !contentLoading || isDocumentCached;

    return (
        <div>
            <CustomMindmapProvider>
                {showChrome && <Header />}
                <div style={{ display: 'flex' }}>
                    <MindMapContainer
                        contentLoading={contentLoading}
                        setContentLoading={setContentLoading}
                    />
                </div>
            </CustomMindmapProvider>
            {!contentLoading &&
                <div className='chatbox-container'>
                    <ChatBox id={documentId} />
                </div>
            }
            {!contentLoading && <SocketListener />}
        </div>
    )
}

export default MainLayout;